<panel style="min-width: 650px">
  @if (accountingPlanSetup) {
    <menu always-visible>
      @if (canBeDeleted() === undefined) {
        <menuitem [disabled]="true" icon="trash"><skeleton /></menuitem>
      }
      @if (canBeDeleted() === false) {
        <menuitem [disabled]="true" icon="trash">{{ 'accounting-plan-setup.delete' | translate }} ({{ 'accounting-plan-setup.delete.in-use' | translate }})</menuitem>
      }
      @if (canBeDeleted() === true) {
        <menuitem (click)="confirmDelete()" icon="trash">{{ 'accounting-plan-setup.delete' | translate }}</menuitem>
      }
    </menu>
  }
  <h1>{{ getHeader() }}</h1>
  @if (!loadingDone()) {
    <section>
      <skeletons [customSkeletons]="[['1em', '100%', 'col-6'], ['2em', '100%', 'col-12']]" class="row" />
      <skeletons [customSkeletons]="[['1em', '100%', 'col-6'], ['2em', '100%', 'col-12']]" class="row" />
      <skeletons [customSkeletons]="[['1em', '100%', 'col-6'], ['2em', '100%', 'col-12']]" class="row" />
      <skeletons [customSkeletons]="[['1em', '100%', 'col-6'], ['2em', '100%', 'col-12']]" class="row" />
      <skeletons [customSkeletons]="[['1em', '100%', 'col-6'], ['2em', '100%', 'col-12']]" class="row" />
      <skeletons [customSkeletons]="[['1em', '100%', 'col-6'], ['2em', '100%', 'col-12']]" class="row" />
    </section>
  }
  @if (loadingDone()) {
    <section>
      <custom-input [label]="'accounting-plan-setup.name' | translate" [inputType]="inputType.Text" [(value)]="accountingPlanSetup.name" [required]="true" />
      <custom-select [label]="'accounting-plan-setup.product-dimension-code' | translate"
        [selectList]="productDimensionsSelect"
        [(value)]="selectedProductDimension"
      [required]="true"></custom-select>
      <custom-select [label]="'accounting-plan-setup.export-type' | translate"
        [selectList]="exportTypeSelect"
        [(value)]="selectedExportType"
      [required]="true"></custom-select>
      <custom-select [label]="'accounting-plan-setup.export-type-no' | translate"
        [selectList]="exportTypeNoSelect"
        [(value)]="selectedExportTypeNo"
      [required]="true"></custom-select>
      <custom-input [label]="'accounting-plan-setup.startup' | translate" [inputType]="inputType.Percentage" [(value)]="accountingPlanSetup.startup" [required]="true" [validation]="validationType.Percent" />
    </section>
  }
  <section>
    <button confirm #saveButton (click)="saveAccountingPlanSetup()">{{ 'general.save' | translate }}</button>
  </section>
</panel>

